<template>
     <div class="container-syarat">
        <p style="font-weight: 800;">Update Syarat dan ketentuan</p>
        <div class="panel-syarat">
            <SyaratKetentuanPanel/>
        </div>
        <div class="panel-syarat-bottom">
            <v-checkbox
            label="Saya setuju dengan syarat dan ketentuan"
            v-model="checkbox"
            :rules="[(v) => !!v || 'You must agree to continue!']"
            required
        >
        </v-checkbox>
        <v-btn class="primary" @click.native="kirimsyaratketentuan()">Kirim</v-btn>
        </div>
     </div>
</template>
<script>
import SyaratKetentuanPanel from '@/components/SyaratKetentuanPanel'
import { mapActions } from 'vuex'
export default {
  name: 'SyaratKetentuan',
  components: {
    SyaratKetentuanPanel
  },
  data: () => ({
    checkbox: false
  }),
  methods: {
    ...mapActions('authentication', ['updateSyaratketentuan']),
    kirimsyaratketentuan () {
      if (this.checkbox) {
        console.log('ok')
        this.$store.dispatch('authentication/updateSyaratketentuan')
        console.log('Checkbox is checked')
      } else {
        console.log('Checkbox is unchecked')
      }
    }
  }
}
</script>

<style scoped>
.panel-syarat-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px;
    width: 100%;
    padding-right: 24px;
    bottom: 24px;
    position: fixed;
}
.panel-syarat {
  background-color: #fff;
  margin-top: 0px;
  margin-right: 4px;
  max-height: calc(100vh - 220px);
  overflow: scroll;
}
.container-syarat {
    padding: 0px;
    margin-right: 14px;
}
</style>
